{
  "$id": "urn:dm:schemas:commonSchemas.json",
  "RefArray": {
    "allOf": [
      {
        "$ref": "urn:dm:schemas:common.json#/DataNode"
      },
      {
        "type": "object",
        "isTopLevelDataNode": true,
        "properties": {
          "values": {
            "items": [
              {
                "type": [
                  "null",
                  "string"
                ],
                "pseudoType": [
                  "ref"
                ]
              }
            ],
            "default": [],
            "type": [
              "array"
            ],
            "pseudoType": [
              "refList"
            ],
            "_wixReference": true,
            "shouldCollect": true,
            "shouldValidate": true,
            "referencedMap": "#",
            "refTypes": []
          }
        }
      }
    ]
  },
  "VariantRelation": {
    "allOf": [
      {
        "$ref": "urn:dm:schemas:common.json#/DataNode"
      },
      {
        "type": "object",
        "isTopLevelDataNode": true,
        "required": [
          "variants",
          "from",
          "to"
        ],
        "properties": {
          "variants": {
            "type": "array",
            "items": {
              "shouldCollect": true,
              "isRefOwner": false,
              "shouldValidate": true,
              "referencedMap": "variants_data",
              "refTypes": [
                "Hover",
                "Mobile",
                "State",
                "Selected",
                "Trigger",
                "Preset",
                "RepeaterPattern",
                "BreakpointRange",
                "NamedRange"
              ],
              "$ref": "urn:dm:schemas:common.json#/weakReference"
            },
            "default": []
          },
          "remoteVariants": {
            "type": "array",
            "items": {
              "shouldCollect": false,
              "isRefOwner": false,
              "shouldValidate": false,
              "referencedMap": "variants_data",
              "$ref": "urn:dm:schemas:common.json#/weakReference"
            }
          },
          "from": {
            "type": [
              "string"
            ]
          },
          "to": {
            "$ref": "urn:dm:schemas:common.json#/reference",
            "shouldCollect": true,
            "shouldValidate": true,
            "referencedMap": "#",
            "refTypes": []
          }
        }
      }
    ]
  },
  "MinimalUnitSize": {
    "type": "object",
    "required": [
      "value",
      "type"
    ],
    "isTopLevelDataNode": false,
    "properties": {
      "value": {
        "type": "number"
      },
      "type": {
        "enum": [
          "px",
          "percentage"
        ]
      }
    }
  },
  "UnitSize": {
    "type": "object",
    "required": [
      "value",
      "type"
    ],
    "isTopLevelDataNode": false,
    "properties": {
      "value": {
        "type": "number"
      },
      "type": {
        "enum": [
          "px",
          "em",
          "rem",
          "fr",
          "percentage",
          "vh",
          "vw",
          "spx",
          "siteWidthPercentage"
        ]
      }
    }
  },
  "SPXReferenceDefinition": {
    "type": "object",
    "required": [
      "refWidth",
      "resolverType"
    ],
    "isTopLevelDataNode": false,
    "properties": {
      "refWidth": {
        "type": "number",
        "multipleOf": 1,
        "minimum": 1
      },
      "resolverType": {
        "type": "string",
        "enum": [
          "scale",
          "fixed"
        ]
      }
    }
  },
  "UnitLength": {
    "type": "object",
    "required": [
      "value",
      "type"
    ],
    "isTopLevelDataNode": false,
    "properties": {
      "value": {
        "type": "number"
      },
      "type": {
        "enum": [
          "px",
          "em",
          "rem",
          "vh",
          "vw",
          "vmin",
          "vmax"
        ]
      }
    }
  },
  "UnitLengthPercentage": {
    "type": "object",
    "required": [
      "value",
      "type"
    ],
    "isTopLevelDataNode": false,
    "properties": {
      "value": {
        "type": "number"
      },
      "type": {
        "enum": [
          "px",
          "em",
          "rem",
          "percentage",
          "vh",
          "vw",
          "vmin",
          "vmax"
        ]
      }
    }
  },
  "UnitAngle": {
    "type": "object",
    "required": [
      "value",
      "type"
    ],
    "isTopLevelDataNode": false,
    "properties": {
      "value": {
        "type": "number"
      },
      "type": {
        "enum": [
          "deg",
          "percentage"
        ]
      }
    }
  },
  "UnitSizeArea": {
    "type": "object",
    "isTopLevelDataNode": false,
    "properties": {
      "width": {
        "$ref": "#/UnitLengthPercentage"
      },
      "height": {
        "$ref": "#/UnitLengthPercentage"
      }
    }
  },
  "UnitSizePoint": {
    "type": "object",
    "isTopLevelDataNode": false,
    "properties": {
      "x": {
        "$ref": "#/UnitLengthPercentage"
      },
      "y": {
        "$ref": "#/UnitLengthPercentage"
      }
    }
  },
  "NumberThatCanConnectToAVariable": {
    "type": "number"
  },
  "LinkReference": {
    "pattern": "^$|^#",
    "refTypes": [
      "ExternalLink",
      "EmailLink",
      "PhoneLink",
      "WhatsAppLink",
      "PageLink",
      "AddressLink",
      "AnchorLink",
      "DynamicPageLink",
      "TpaPageLink",
      "DocumentLink",
      "FormSubmitButtonLink",
      "LoginToWixLink"
    ],
    "isTopLevelDataNode": false,
    "$ref": "urn:dm:schemas:common.json#/nullableReference",
    "shouldCollect": true,
    "shouldValidate": true,
    "referencedMap": "#"
  },
  "Common_Image": {
    "allOf": [
      {
        "$ref": "urn:dm:schemas:common.json#/DataNode"
      },
      {
        "type": "object",
        "isTopLevelDataNode": true,
        "properties": {
          "link": {
            "$ref": "#/LinkReference"
          },
          "title": {
            "type": "string",
            "default": "",
            "maxLength": 100,
            "description": "Title or caption for the image."
          },
          "name": {
            "type": "string",
            "maxLength": 100,
            "description": "Name identifier for the image."
          },
          "uri": {
            "type": "string",
            "pattern": "^[\\w:~\\-_+%.\\/,\\?=\\()]+$",
            "default": "3963cf22f5e14a25a77ebe37298a8d3b.png",
            "description": "Represents the URI or path to the image."
          },
          "description": {
            "type": "string",
            "maxLength": 1200,
            "description": "Textual description or details about the image."
          },
          "height": {
            "type": "number",
            "default": 200,
            "description": "Height dimension of the image."
          },
          "width": {
            "type": "number",
            "default": 200,
            "description": "Width dimension of the image."
          },
          "borderSize": {
            "type": "string",
            "description": "Size of the border around the image."
          },
          "alt": {
            "type": "string",
            "default": "",
            "description": "Alternative text for the image (for accessibility purposes)."
          },
          "decorative": {
            "type": "boolean"
          },
          "hasAnimation": {
            "type": "boolean",
            "description": "Indicates whether the image has animation valid for images in webP format"
          },
          "originalImageDataRef": {
            "description": "Original Image before edit",
            "refTypes": [
              "Image"
            ],
            "$ref": "urn:dm:schemas:common.json#/nullableReference",
            "shouldCollect": true,
            "shouldValidate": true,
            "referencedMap": "#"
          },
          "opacity": {
            "type": "number",
            "description": "Opacity level of the image."
          },
          "crop": {
            "oneOf": [
              {
                "type": "null"
              },
              {
                "type": "object",
                "minProperties": 4,
                "properties": {
                  "x": {
                    "type": "number",
                    "minimum": 0
                  },
                  "y": {
                    "type": "number",
                    "minimum": 0
                  },
                  "width": {
                    "type": "number",
                    "minimum": 0
                  },
                  "height": {
                    "type": "number",
                    "minimum": 0
                  },
                  "svgId": {
                    "type": "string",
                    "description": "Defines an svg uri for a mask inside the crop boundaries"
                  },
                  "flip": {
                    "type": "string",
                    "enum": [
                      "x",
                      "y",
                      "xy",
                      "none"
                    ],
                    "description": "Defines whether the mask is flipped on the v or h axis"
                  },
                  "rotate": {
                    "type": "number",
                    "minimum": 0,
                    "maximum": 360,
                    "description": "Defines a rotation angle for the mask"
                  }
                }
              }
            ],
            "description": "Defines cropping boundaries and additional transformations for the image."
          },
          "upscaleMethod": {
            "type": "string",
            "description": "used for upscaling method when building an image url , expected values default|super"
          },
          "focalPoint": {
            "oneOf": [
              {
                "type": "null"
              },
              {
                "type": "object",
                "minProperties": 2,
                "properties": {
                  "x": {
                    "type": "number",
                    "minimum": 0,
                    "maximum": 100
                  },
                  "y": {
                    "type": "number",
                    "minimum": 0,
                    "maximum": 100
                  }
                }
              }
            ],
            "description": "Specifies the focal point within the image."
          },
          "artist": {
            "type": "object",
            "description": "Information about the artist of the image.",
            "properties": {
              "name": {
                "type": "string"
              },
              "id": {
                "type": "string"
              }
            }
          }
        }
      }
    ]
  },
  "Common_SVGItem": {
    "allOf": [
      {
        "$ref": "urn:dm:schemas:common.json#/DataNode"
      },
      {
        "type": "object",
        "isTopLevelDataNode": true,
        "properties": {
          "svgId": {
            "type": "string",
            "maxLength": 100
          }
        }
      }
    ]
  },
  "ColorLayers": {
    "shouldCollect": true,
    "shouldValidate": true,
    "refTypes": [
      "GradientLinearLayer",
      "GradientCircleLayer",
      "GradientEllipseLayer",
      "GradientConicLayer",
      "GradientMeshLayer",
      "SolidColorLayer"
    ],
    "type": [
      "array",
      "null"
    ],
    "items": [
      {
        "type": [
          "null",
          "string"
        ],
        "pseudoType": [
          "ref"
        ]
      }
    ],
    "pseudoType": [
      "refList"
    ],
    "_wixReference": true,
    "referencedMap": "#"
  },
  "GradientLinearLayer": {
    "allOf": [
      {
        "$ref": "urn:dm:schemas:common.json#/DataNode"
      },
      {
        "type": "object",
        "isTopLevelDataNode": true,
        "properties": {
          "opacity": {
            "type": "number",
            "minimum": 0,
            "maximum": 1
          },
          "fill": {
            "$ref": "#/GradientLinear"
          }
        }
      }
    ]
  },
  "GradientCircleLayer": {
    "allOf": [
      {
        "$ref": "urn:dm:schemas:common.json#/DataNode"
      },
      {
        "type": "object",
        "isTopLevelDataNode": true,
        "properties": {
          "opacity": {
            "type": "number",
            "minimum": 0,
            "maximum": 1
          },
          "fill": {
            "$ref": "#/GradientCircle"
          }
        }
      }
    ]
  },
  "GradientEllipseLayer": {
    "allOf": [
      {
        "$ref": "urn:dm:schemas:common.json#/DataNode"
      },
      {
        "type": "object",
        "isTopLevelDataNode": true,
        "properties": {
          "opacity": {
            "type": "number",
            "minimum": 0,
            "maximum": 1
          },
          "fill": {
            "$ref": "#/GradientEllipse"
          }
        }
      }
    ]
  },
  "GradientMeshLayer": {
    "allOf": [
      {
        "$ref": "urn:dm:schemas:common.json#/DataNode"
      },
      {
        "type": "object",
        "isTopLevelDataNode": true,
        "properties": {
          "opacity": {
            "type": "number",
            "minimum": 0,
            "maximum": 1
          },
          "fill": {
            "type": "object",
            "isTopLevelDataNode": false,
            "properties": {
              "type": {
                "type": "string",
                "enum": [
                  "GradientMesh"
                ]
              },
              "gradients": {
                "type": "array",
                "items": {
                  "$ref": "#/GradientCircle"
                }
              }
            }
          }
        }
      }
    ]
  },
  "GradientConicLayer": {
    "allOf": [
      {
        "$ref": "urn:dm:schemas:common.json#/DataNode"
      },
      {
        "type": "object",
        "isTopLevelDataNode": true,
        "properties": {
          "opacity": {
            "type": "number",
            "minimum": 0,
            "maximum": 1
          },
          "fill": {
            "$ref": "#/GradientConic"
          }
        }
      }
    ]
  },
  "SolidColorLayer": {
    "allOf": [
      {
        "$ref": "urn:dm:schemas:common.json#/DataNode"
      },
      {
        "type": "object",
        "isTopLevelDataNode": true,
        "properties": {
          "opacity": {
            "type": "number",
            "minimum": 0,
            "maximum": 1
          },
          "fill": {
            "$ref": "#/SolidColor"
          }
        }
      }
    ]
  },
  "GradientLinear": {
    "type": "object",
    "isTopLevelDataNode": false,
    "properties": {
      "type": {
        "type": "string",
        "enum": [
          "GradientLinear"
        ]
      },
      "repeat": {
        "type": "boolean"
      },
      "blendMode": {
        "$ref": "#/BlendMode"
      },
      "angle": {
        "type": "number",
        "minimum": 0,
        "maximum": 360
      },
      "colorStops": {
        "type": "array",
        "items": {
          "$ref": "#/GradientColorStop"
        }
      }
    }
  },
  "GradientCircleSize": {
    "type": "object",
    "oneOf": [
      {
        "required": [
          "value",
          "type"
        ]
      },
      {
        "required": [
          "keyword"
        ]
      },
      {
        "required": [],
        "maxProperties": 0
      }
    ],
    "isTopLevelDataNode": false,
    "properties": {
      "keyword": {
        "type": "string",
        "enum": [
          "closest-side",
          "closest-corner",
          "farthest-side",
          "farthest-corner"
        ]
      },
      "value": {
        "type": "number"
      },
      "type": {
        "enum": [
          "px",
          "em",
          "rem",
          "vh",
          "vw",
          "vmin",
          "vmax"
        ]
      }
    }
  },
  "GradientCircle": {
    "type": "object",
    "isTopLevelDataNode": false,
    "properties": {
      "type": {
        "type": "string",
        "enum": [
          "GradientCircle"
        ]
      },
      "repeat": {
        "type": "boolean"
      },
      "blendMode": {
        "$ref": "#/BlendMode"
      },
      "size": {
        "$ref": "#/GradientCircleSize"
      },
      "position": {
        "$ref": "#/UnitSizePoint"
      },
      "colorStops": {
        "type": "array",
        "items": {
          "$ref": "#/GradientColorStop"
        }
      }
    }
  },
  "GradientEllipseSize": {
    "type": "object",
    "oneOf": [
      {
        "required": [
          "width",
          "height"
        ]
      },
      {
        "required": [
          "keyword"
        ]
      }
    ],
    "isTopLevelDataNode": false,
    "properties": {
      "keyword": {
        "type": "string",
        "enum": [
          "closest-side",
          "closest-corner",
          "farthest-side",
          "farthest-corner"
        ]
      },
      "width": {
        "$ref": "#/UnitLengthPercentage"
      },
      "height": {
        "$ref": "#/UnitLengthPercentage"
      }
    }
  },
  "GradientEllipse": {
    "type": "object",
    "isTopLevelDataNode": false,
    "properties": {
      "type": {
        "type": "string",
        "enum": [
          "GradientEllipse"
        ]
      },
      "repeat": {
        "type": "boolean"
      },
      "blendMode": {
        "$ref": "#/BlendMode"
      },
      "size": {
        "$ref": "#/GradientEllipseSize"
      },
      "position": {
        "$ref": "#/UnitSizePoint"
      },
      "colorStops": {
        "type": "array",
        "items": {
          "$ref": "#/GradientColorStop"
        }
      }
    }
  },
  "GradientConic": {
    "type": "object",
    "isTopLevelDataNode": false,
    "properties": {
      "type": {
        "type": "string",
        "enum": [
          "GradientConic"
        ]
      },
      "repeat": {
        "type": "boolean"
      },
      "blendMode": {
        "$ref": "#/BlendMode"
      },
      "angle": {
        "type": "number",
        "minimum": 0,
        "maximum": 360
      },
      "position": {
        "$ref": "#/UnitSizePoint"
      },
      "colorStops": {
        "type": "array",
        "items": {
          "$ref": "#/GradientAngularColorStop"
        }
      }
    }
  },
  "SolidColor": {
    "type": "object",
    "isTopLevelDataNode": false,
    "properties": {
      "type": {
        "type": "string",
        "enum": [
          "SolidColor"
        ]
      },
      "color": {
        "$ref": "urn:dm:schemas:common.json#/color"
      }
    }
  },
  "BlendMode": {
    "type": "string",
    "enum": [
      "normal",
      "multiply",
      "screen",
      "darken",
      "lighten",
      "overlay",
      "colorDodge",
      "colorBurn",
      "hardLight",
      "softLight",
      "difference",
      "exclusion",
      "hue",
      "saturation",
      "color",
      "luminosity"
    ],
    "isTopLevelDataNode": false
  },
  "GradientColorStop": {
    "type": "object",
    "isTopLevelDataNode": false,
    "properties": {
      "size": {
        "$ref": "#/UnitLengthPercentage"
      },
      "color": {
        "$ref": "urn:dm:schemas:common.json#/color"
      },
      "opacity": {
        "type": "number",
        "minimum": 0,
        "maximum": 1
      }
    }
  },
  "GradientAngularColorStop": {
    "type": "object",
    "isTopLevelDataNode": false,
    "properties": {
      "size": {
        "$ref": "#/UnitAngle"
      },
      "color": {
        "$ref": "urn:dm:schemas:common.json#/color"
      },
      "opacity": {
        "type": "number",
        "minimum": 0,
        "maximum": 1
      }
    }
  }
}
